import React from 'react';
import classNames from 'classnames';
import styles from './TextBox.module.scss';

export interface TextBoxProps {
  label: string;
  children: React.ReactNode;
  className?: string;
  labelClassName?: string;
}

export const TextBox = (props: TextBoxProps) => {
  const { children, label, className, labelClassName } = props;

  return (
    <div className={classNames(className, styles.container)}>
      <div className={classNames(labelClassName, styles.label)}>{label}</div>
      <div className={styles.value}>{children}</div>
    </div>
  );
};
